import {
    UPDATE_SCHEDULE_NOTIFICATION_SUCCESS,
    UPDATE_SCHEDULE_NOTIFICATION_FAILURE
} from '../actions/types'

const initialState = {
    updateNotification: null,
    loading: false,
    error: null,
};

export const updateNotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SCHEDULE_NOTIFICATION_SUCCESS:
            return {
                ...state,
                updateNotification: action.payload,
                loading: false,
                error: null,
            };

        case UPDATE_SCHEDULE_NOTIFICATION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};